import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FaHeart, FaStar } from "react-icons/fa";

const API = "http://localhost:8500/api/v1";

const AllProduct = () => {
  const { subCategoryName } = useParams();
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  // 👤 user
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;
  const wishlistKey = userId ? `wishlist_${userId}` : null;

  // 📦 Fetch Products
  useEffect(() => {
    fetch(`${API}/getsubcategoryproduct/${subCategoryName}`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.result || []);
      })
      .catch((err) => console.error(err));
  }, [subCategoryName]);

  // ❤️ Load wishlist
  useEffect(() => {
    if (!wishlistKey) return;
    const data = JSON.parse(localStorage.getItem(wishlistKey)) || [];
    setWishlist(data);
  }, [wishlistKey]);

  // ❤️ Toggle wishlist
  const toggleWishlist = (product) => {
    let updated = [...wishlist];

    const index = updated.findIndex((item) => item._id === product._id);

    if (index > -1) {
      updated.splice(index, 1);
    } else {
      updated.push(product);
    }

    setWishlist(updated);
    localStorage.setItem(wishlistKey, JSON.stringify(updated));
  };

  // ⭐ rating
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <FaStar
        key={i}
        size={14}
        className={i < rating ? "text-yellow-400" : "text-gray-300"}
      />
    ));
  };

  return (
    <div className="py-10 bg-white">
      <div className="max-w-[1400px] mx-auto px-4">

        {/* 🔥 Heading */}
        <h2 className="text-center text-3xl font-bold text-[#187685] mb-10">
          {subCategoryName}
        </h2>

        {/* GRID */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">

          {products.length === 0 ? (
            <p>No products found</p>
          ) : (
            products.map((product) => {
              const reviews = product.review || [];
              const avgRating =
                reviews.length > 0
                  ? Math.round(
                      reviews.reduce(
                        (sum, r) => sum + Number(r.rating || 0),
                        0
                      ) / reviews.length
                    )
                  : 0;

              const isWishlisted = wishlist.some(
                (item) => item._id === product._id
              );

              return (
                <div
                  key={product._id}
                  className="bg-white rounded-[25px] p-4 shadow-sm hover:shadow-lg transition relative"
                >
                  {/* ❤️ Wishlist */}
                  <div
                    onClick={() => toggleWishlist(product)}
                    className="absolute top-3 right-3 cursor-pointer"
                  >
                    <FaHeart
                      size={18}
                      className={
                        isWishlisted ? "text-red-500" : "text-gray-300"
                      }
                    />
                  </div>

                  {/* 🖼 Image */}
                  <Link to={`/product/${product._id}`} state={{ product }}>
                    <div className="bg-[#F9FAFB] rounded-[20px] h-[200px] flex items-center justify-center">
                      <img
                        src={`https://mediapi.onlinepharmaque.in/uploads/${product.pImg?.[0]}`}
                        alt={product.pName}
                        className="h-[160px] object-contain"
                      />
                    </div>
                  </Link>

                  {/* 📦 Name */}
                  <p className="mt-4 text-sm font-semibold line-clamp-2">
                    {product.pName}
                  </p>

                  {/* 💰 Price + ⭐ */}
                  <div className="flex items-center justify-between mt-3">
                    <span className="text-lg font-bold text-[#187685]">
                      ₹{product.price}
                    </span>

                    <div className="flex gap-1">
                      {product.ratestar}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
};

export default AllProduct;